jQuery(document).ready(function($) {

	"use strict";

	function modalSuccessResponseHandler(target, data, xhr) {
		if ('application/json' == xhr.getResponseHeader('content-type')) {
			target.trigger('loaded.ajax.json', data);
		}
		else {
			target.trigger('loaded.ajax.html', data);
		}
	}

	function modalErrorResponseHandler(target) {
		target.trigger('error.ajax', target);
	}

	$('.modal-ajax').each(function(){

		var modal = $(this);
		var loadingIndicator = modal.find('.modal-header .modal__loading-indicator');

		modal.removeClass('loading');

		modal
			.on('loaded.ajax.html', function(event, ajaxData) {
				var dataContent = $(ajaxData);

				var dataUrl = dataContent.filter('meta[data-url]');

				if (typeof dataUrl.attr('data-url') === "undefined") {
					modal.find('.modal-content').html(dataContent);

					// Focus initial-focus field
					modal.find('[data-initial-focus]').focus();
				}
				else {
					modal.addClass('loading'); // Show it again so the user has a visual clue of the current loading state

					window.location = dataUrl.attr('data-url');
				}
			})

			.on('error.ajax.modal', function(event, target){
				target = $(target);

				target.find('input[type="submit"], button').blur();
			})

			.on('loaded.bs.modal loaded.ajax.html loaded.ajax.json error.ajax', function(){
				modal.removeClass('loading');
				modal.find('.modal-header').append(loadingIndicator);

				// Only clear modal after ajax request
				modal.one('hidden.bs.modal', function () {
					modal.removeData('bs.modal');
				});
			})

			.on('loaded.bs.modal loaded.ajax.html loaded.ajax.json', function(event){
				// The modal is hidden. Prevent bubbling from this point
				if (modal.data('bs.modal').isShown == false) {
					event.stopPropagation();
				}
			})

			// show.bs.modal
			.on('show.bs.modal', function(event){
				if (modal.data('initial-loading') != false && typeof modal.data('bs.modal').options.remote != 'undefined') {
					modal.addClass('loading');
				}
			})

			// On form submit
			.on('submit', 'form', function(event) {
				event.preventDefault();

				modal.addClass('loading');

				var form = $(this);

				$.ajax({
					type: form.attr('method'),
					url: form.attr('action'),
					data: form.serialize(),
					timeout: window.appConfig.ajaxRequest.timeout,

					success: function(data, status, xhr) {
						modalSuccessResponseHandler(modal, data, xhr);
					},

					error: function(xhr, status, error) {
						modalErrorResponseHandler(modal);
					}
				});
			})

			// Click on a ajax-enabled link
			.on('click', 'a[data-ajax-request="true"]', function(event) {
				event.preventDefault();

				modal.addClass('loading');

				var ajaxUrl = $(this).attr("href");

				$.ajax({
					type: "get",
					url: ajaxUrl,
					data: {
						'remote': true
					},
					timeout: window.appConfig.ajaxRequest.timeout,

					success: function(data, status, xhr) {
						modalSuccessResponseHandler(modal, data, xhr);
					},

					error: function(xhr, status, error) {
						modalErrorResponseHandler(modal);
					}
				});
			});
	});
});
